import type { ReactNode } from 'react'
import { X } from 'lucide-react'

export interface ModalProps {
  open: boolean
  title: string
  onClose: () => void
  children: ReactNode
  footer?: ReactNode
}

// Generic form-hosting dialog base. ConfirmModal (PRD 00) is confirm/cancel
// only - a string description and a hardcoded danger confirm button - which
// doesn't fit a real form like "Add Document Type"'s checkbox list + group
// selector. This sits alongside ConfirmModal rather than refactoring it,
// since that refactor is beyond this PRD's scope.
export function Modal({ open, title, onClose, children, footer }: ModalProps) {
  if (!open) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-bg/80">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
        className="flex max-h-[80vh] w-[480px] flex-col gap-4 rounded-control border border-border bg-surface-raised p-6"
      >
        <div className="flex items-center justify-between">
          <h2 id="modal-title" className="text-header font-semibold text-text-primary">
            {title}
          </h2>
          <button
            type="button"
            aria-label="Close"
            onClick={onClose}
            className="text-text-secondary hover:text-text-primary"
          >
            <X size={18} strokeWidth={1.5} />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto">{children}</div>
        {footer && <div className="flex justify-end gap-2">{footer}</div>}
      </div>
    </div>
  )
}
